import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LanguageIcon from '@mui/icons-material/Language';
import { Box } from '@mui/system';
import { IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import { Business } from '@interfaces/register';

export const SocialIcons = ({ profile }: { profile: Business }) => {
    return (
        <Box my={4} sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-start' } }}>
            {profile?.facebook && (
                <IconButton color="primary" aria-label="Facebook" target="_blank" component={Link} to={{ pathname: `${profile?.facebook}` }} >
                    <FacebookIcon />
                </IconButton>
            )}
            {profile?.twitter && (
                <IconButton color="primary" aria-label="Twitter" target="_blank" component={Link} to={{ pathname: `${profile?.twitter}` }}>
                    <TwitterIcon />
                </IconButton>
            )}
            {profile?.instagram && (
                <IconButton color="primary" aria-label="Instagram" target="_blank" component={Link} to={{ pathname: `${profile?.instagram}` }}>
                    <InstagramIcon />
                </IconButton>
            )}
            {profile?.website && (
                <IconButton color="primary" aria-label="Web" target="_blank" component={Link} to={{ pathname: `${profile?.website}` }}>
                    <LanguageIcon />
                </IconButton>
            )}
        </Box>
    )
}
